import { useNavigate } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { useConfig, whatsappLink } from "@/context/ConfigContext";
import { track } from "@/lib/analytics";

// Floating WhatsApp button + mobile sticky Order/WhatsApp bar.
export const WhatsAppFab = ({ showOrder = true }) => {
  const config = useConfig();
  const navigate = useNavigate();

  return (
    <>
      {/* Desktop / tablet floating WhatsApp */}
      <a
        href={whatsappLink(config)}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="whatsapp-fab"
        onClick={() => track("whatsapp_click", { location: "fab" })}
        className="fixed bottom-6 right-6 z-50 hidden h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-transform hover:scale-105 sm:flex"
        aria-label="Chat on WhatsApp"
      >
        <MessageCircle className="h-7 w-7" />
      </a>

      {/* Mobile sticky bottom bar */}
      <div className="fixed inset-x-0 bottom-0 z-50 flex gap-2 border-t border-border bg-background/95 p-3 backdrop-blur sm:hidden">
        {showOrder && (
          <button
            data-testid="sticky-order-now"
            onClick={() => {
              track("order_now_click", { location: "sticky" });
              navigate("/order");
            }}
            className="flex-1 rounded-sm bg-primary py-3 text-sm font-semibold text-primary-foreground"
          >
            Order Now
          </button>
        )}
        <a
          href={whatsappLink(config)}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="sticky-whatsapp"
          onClick={() => track("whatsapp_click", { location: "sticky" })}
          className="flex items-center justify-center gap-2 rounded-sm bg-[#25D366] px-4 py-3 text-sm font-semibold text-white"
        >
          <MessageCircle className="h-5 w-5" /> WhatsApp
        </a>
      </div>
    </>
  );
};
